import React, { useEffect, useState } from "react";
import { Button, Form, Input, Select } from "antd";
import { BundleInterface } from "src/store/gh_market/bundlesSlice";

const { TextArea } = Input;

interface propsInterface {
  params?: BundleInterface | any;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();
  const [platform, setPlatform] = useState<string>(params?.platform || 'ios');

  useEffect(() => {
    form.resetFields();
    setPlatform(params?.platform || 'ios');
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='name' label="Bundle Name" rules={[{ required: true }]}>
        <Input placeholder="com.example.app" disabled={!!params?.id} />
      </Form.Item>

      <Form.Item name='platform' label="Platform" rules={[{ required: true }]}>
        <Select onChange={(value) => setPlatform(value)}>
          <Select.Option value="ios">iOS</Select.Option>
          <Select.Option value="android">Android</Select.Option>
        </Select>
      </Form.Item>

      {platform === 'ios' && (
        <Form.Item name='shared_secret' label="Shared Secret">
          <Input placeholder="Apple shared secret" />
        </Form.Item>
      )}

      {platform === 'android' && (
        <>
          <Form.Item name='iss' label="ISS (Service Account Email)">
            <Input placeholder="service-account@project.iam.gserviceaccount.com" />
          </Form.Item>

          <Form.Item name='rsa_private_key' label="RSA Private Key">
            <TextArea rows={6} placeholder="-----BEGIN PRIVATE KEY-----" />
          </Form.Item>
        </>
      )}

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
}

export default _Form;
